import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const tokenLink = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    downstreamTokenId: z.uuid().hidden().describe('Foreign key to Token'),

    upstreamTokenId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Token'),

    downstreamToken: belongsTo('Token'),

    upstreamToken: references('Token', 'upstreamTokenId'),
  })
  .describe('Connects two tokens to show the flow of execution')
  .as('TokenLink');

export { tokenLink as tokenLinkSchema };
